import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { resolvers, queryMap } from './resolvers';
import {
  restResourceCacheRedirects,
  batchRestResourceCacheRedirects,
} from './restResourceResolver/restResourceCacheRedirects';
import typeDefs from './schema';
import { TrelloWindow } from '@trello/window-types';
declare const window: TrelloWindow;

const cache = new InMemoryCache({
  cacheRedirects: {
    Query: {
      // Add cacheRedirects (https://www.apollographql.com/docs/react/advanced/caching/#cache-redirects-with-cacheredirects)
      // for any restResourceResolvers/batchRestResourceResolvers used as Query resolvers to ensure we can grab entities by
      // id
      ...restResourceCacheRedirects(queryMap),
      ...batchRestResourceCacheRedirects(queryMap),
    },
  },
});

export const client = new ApolloClient({
  cache,
  resolvers,
  typeDefs,
  ...(window.__DEV__ && { connectToDevTools: true }),
});
